// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","executivesList":"KCvy1E3rdM7DJ-Z7238k8"};